import {HttpContextToken} from '@angular/common/http';

export const CALL_CTX = new HttpContextToken<CallContext>(() => undefined);
// export const CUSTOM_HEADER = new HttpContextToken<string>(() => '');

export enum ShowMessage {
    default,
    show,
    hide
}

export interface CallContext {
    skipLoading: boolean,
    showSuccessMessage: ShowMessage,
    successMessage?: string,
    persistentSuccessMessage: boolean,
    showErrorMessage: ShowMessage,
    persistentErrorMessage: boolean,
    muteMessages: boolean,
}

export function getCallContext(skipLoading: boolean = false,
                               showSuccessMessage: ShowMessage = ShowMessage.default,
                               persistentSuccessMessage: boolean = false,
                               persistentErrorMessage: boolean = false,
                               showErrorMessage: ShowMessage = ShowMessage.show,
                               muteMessages: boolean = false,
                               successMessage?: string,
                ): CallContext {
    return {
        skipLoading: skipLoading,
        showSuccessMessage: showSuccessMessage,
        persistentSuccessMessage: persistentSuccessMessage,
        successMessage: successMessage,
        showErrorMessage: showErrorMessage,
        muteMessages: muteMessages,
        persistentErrorMessage: persistentErrorMessage,
    }
}
